import { Callout } from "./callout";
import { HandshakeIcon } from "lucide-react";
import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";

export const PricingCard = () => {
  return (
    <Card className="relative h-full overflow-clip px-8">
      <div className="flex justify-around md:flex-wrap">
        <div className="relative">
          <Callout>Pricing</Callout>
          <p className="my-4 text-2xl">Add Revenue. Add Value.</p>
          <div className="space-y-6 font-serif max-sm:text-lg/8">
            <p>
              When you use Flash's system for ID verification and facial recognition, there's no
              cost to get started. We charge a flat fee for each identity verified. If you're
              integrating Flash's verification services into your own platform, you can set your own
              pricing for the age verification or ID check—adding a valuable feature to your
              platform and unlocking a new revenue stream.
            </p>
            <p>
              For example, if you're a club owner looking to offer VIP access or faster event entry
              using facial recognition, our system enhances your platform while giving you full
              control over how you monetize it.
            </p>
          </div>
        </div>
      </div>
      <Ping />
    </Card>
  );
};

const LOOP_DURATION = 6;

const Ping = () => {
  return (
    <div className="absolute bottom-0 left-1/2 w-fit -translate-x-1/2 translate-y-1/2 max-xl:hidden">
      <HandshakeIcon className="not-sr-only relative z-10 -mt-10 size-9 text-7xl text-blue-100" />
      <Band delay={0} />
      <Band delay={LOOP_DURATION * 0.25} />
      <Band delay={LOOP_DURATION * 0.5} />
      <Band delay={LOOP_DURATION * 0.75} />
    </div>
  );
};

const Band = ({ delay }: { delay: number }) => {
  return (
    <motion.span
      style={{
        translateX: "-50%",
        translateY: "-50%",
      }}
      initial={{
        opacity: 0,
        scale: 0.25,
      }}
      animate={{
        opacity: [0, 1, 1, 0],
        scale: 1,
      }}
      transition={{
        repeat: Infinity,
        repeatType: "loop",
        times: [0, 0.5, 0.75, 1],
        duration: LOOP_DURATION,
        ease: "linear",
        delay,
      }}
      className="absolute top-[50%] left-[50%] z-0 size-80 rounded-full border border-background bg-linear-to-br from-secondary to-blue-950/20"
    />
  );
};
